module.exports = __webpack_public_path__ + "static/media/logotransparente.a4f84223.png";